module.exports = __webpack_public_path__ + "img/logo_HK - Bioland.e2cf8360.svg";